var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", {}, [
            _c("h4", { staticClass: "mb-0" }, [
              _vm._v("Зарплатная сводная ведомость")
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: { size: "sm", variant: "info" },
                          on: {
                            click: function($event) {
                              return _vm.onExport()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "file-download" }
                          }),
                          _vm._v("\n            Экспорт\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-navbar",
        { attrs: { id: "filters" } },
        [
          _c(
            "b-navbar-nav",
            [
              _c(
                "b-form",
                {
                  attrs: { inline: "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.onSearch()
                    }
                  }
                },
                [
                  _c("month-picker", {
                    staticClass: "mb-1 mr-2",
                    attrs: {
                      label: "Период",
                      placeholder: "Выберите период",
                      "min-year": 2025,
                      clearable: false
                    },
                    model: {
                      value: _vm.filters.period,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "period", $$v)
                      },
                      expression: "filters.period"
                    }
                  }),
                  _vm._v(" "),
                  _c("organization-select", {
                    ref: "organization_select",
                    staticClass: "mb-1 mr-2",
                    attrs: {
                      id: "input-organization-select",
                      value: _vm.filters.org_id
                    },
                    on: { onSelect: _vm.onSelectOrganization }
                  }),
                  _vm._v(" "),
                  _c("department-select", {
                    ref: "department_select",
                    staticClass: "mb-1 mr-2",
                    attrs: {
                      id: "input-department-select",
                      value: _vm.filters.department_id
                    },
                    on: { onSelect: _vm.onSelectDepartment }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mb-1 mr-1",
                      attrs: {
                        size: "sm",
                        variant: "outline-success",
                        type: "submit"
                      }
                    },
                    [_vm._v("\n          Применить\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "salary_summary",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "salary-summary",
          selectable: "",
          "select-mode": "single",
          selectedVariant: "success",
          striped: "",
          small: "",
          responsive: "",
          bordered: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.fields,
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": "",
          "sticky-header": "",
          "head-variant": "light",
          "foot-clone": true,
          "no-footer-sorting": "",
          "tfoot-class": "thead-light"
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(accrual_staff_1_2)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.priceFormat(_vm.getAccrual_staff_1_2_salary(row.item))
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(accrual_staff_5_6)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.priceFormat(_vm.getAccrual_staff_5_6(row.item))
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(accrual_staff_sum)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.priceFormat(_vm.getAccrual_staff_sum(row.item))
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(salary_staff_1)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.priceFormat(_vm.getSalary_staff_1(row.item))) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(salary_staff_2)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.priceFormat(_vm.getSalary_staff_2(row.item))) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(salary_staff_5_6)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.priceFormat(_vm.getSalary_staff_5_6(row.item))) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(salary_staff_sum)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.priceFormat(_vm.getSalary_staff_sum(row.item))) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "foot()",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.price(_vm.calculateTotal(row.field))) +
                    "\n    "
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "b-card-footer",
        { attrs: { id: "footer", "footer-bg-variant": "light" } },
        [
          _c(
            "b-row",
            { attrs: { "align-h": "between", "align-v": "center" } },
            [
              _c("b-col", { staticClass: "mr-auto", attrs: { cols: "auto" } }, [
                _vm._v("\n        Записей: "),
                _c("b", [_vm._v(_vm._s(_vm.totalRows))])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cdbe989", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cdbe989","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SalarySummary/SalarySummary.vue
// module id = null
// module chunks = 